/* Denvia · animación reveal al hacer scroll (se inicializa una sola vez) */
(function () {
  if (window.__mtRevealInit) return;
  window.__mtRevealInit = true;

  function init() {
    var els = document.querySelectorAll('.mt-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Reinicia dentro del editor de Shopify al añadir/mover secciones
  document.addEventListener('shopify:section:load', init);
})();
